<script>
import axios from 'axios'
import DeviceIdModal from '@/vcs/_shared/modals/DeviceIdModal.vue'
import QrModal from '@/vcs/_shared/modals/QrModal.vue'
import CpuWireframe from '@/vcs/_shared/cpu-wireframe/cmp.vue'
import { mapGetters } from 'vuex'
import SupportCollectomateOpenLockerModal from './modals/SupportCollectomateOpenLockerModal.vue'
import SupportRaiseLockerIssueModal from './modals/SupportRaiseLockerIssueModal.vue'
import SupportBoxSelectModal from './modals/SupportBoxSelectModal.vue'

export default {
  name: 'SupportCollectomate',
  components: { CpuWireframe },
  data: function () {
    return {
      boxSelected: null
    }
  },
  computed: {
    ...mapGetters({
      cp: 'getCurrentCp',
      deviceId: 'getDeviceId'
    })
  },
  methods: {
    calculateCpHeight(cp) {
      if (cp.dimensions) {
        return parseInt(cp.dimensions.split(',')[1])
      }
    },
    onCpuSelected(cpu) {
      this.openSupportBoxSelectModal(cpu)
    },
    onBoxSelected(box) {
      this.boxSelected = box
    },
    adminOpenBox(box) {
      this.$blockUI()
      if (this.$dev) {
        this.$unblockUI()
        this.openSupportCollectomateOpenLockerModal(box)
        return
      }

      axios({
        method: 'put',
        url: `/boxes/${box.id}/admin_open`,
        headers: {
          common: {
            Authorization: `Bearer ${window.localStorage.getItem(
              'support_session_token'
            )}`
          }
        }
      })
        .then((response) => {
          this.openSupportCollectomateOpenLockerModal(box)
        })
        .catch((error) => {
          this.$errorHumanized(null, this.$t('error.unableToOpenLocker'))
        })
        .finally(() => {
          this.$unblockUI()
        })
    },
    openSupportBoxSelectModal(cpu) {
      this.$store.commit('modal/open', {
        cmp: SupportBoxSelectModal,
        size: 'full',
        data: { cpu },
        callback: this.onBoxSelected
      })
    },
    openSupportCollectomateOpenLockerModal(box) {
      this.$store.commit('modal/open', {
        cmp: SupportCollectomateOpenLockerModal,
        size: 'full',
        data: { box },
        callback: () => {
          this.fetchCpInfo(this.deviceId)
        }
      })
    },
    openSupportRaiseLockerIssueModal(box) {
      this.$store.commit('modal/open', {
        cmp: SupportRaiseLockerIssueModal,
        size: 'full',
        data: { box },
        callback: () => {
          this.fetchCpInfo(this.deviceId)
        }
      })
    },
    fetchCpInfo(deviceId) {
      this.$blockUI()
      axios({
        method: 'get',
        url: `collection_points/${deviceId}/map`
      })
        .then((response) => {
          this.$store.commit('setCurrentCp', response.data)
        })
        .catch(() => {
          this.$errorHumanized(null, 'Provide correct device id')
        })
        .finally(() => {
          this.$unblockUI()
        })
    }
  }
}
</script>

<template lang="pug">
.route-view.container-fluid
  .page
    h1.page__header.font-weight-bold {{ $t('support.collectomate.header') }}
    h3.page__description.font-weight-bold.mb-5 {{ $t('support.collectomate.subheader') }}

    .row
      .col-12.cp-overflow-wrapper
        .cpus(v-if="cp")
          cpu-wireframe(
            v-for="cpu in cp.units"
            :key="cpu.id"
            :cpu="cpu"
            :cpHeight="calculateCpHeight(cp)"
            :cpOperationKind="cp.operationKind"
            :forcedHeight="300"
            :openedBoxId="(boxSelected || {}).id || ''"
            :isSelected="false"
            @cpu-selected="onCpuSelected($event)"
          )

    .page__footer(:class="{ sticky: false }")
      .row
        .col-12.col-lg-5.text-center.text-lg-left
          button.btn.btn-link.text-danger.mb-3.mb-lg-0(
            type="button"
            v-ea-click="() => {openSupportRaiseLockerIssueModal(boxSelected)}"
            :disabled="!(boxSelected || {}).id"
          ) {{ $t('support.collectomate.openRaiseLockerIssueButton') }}
        .col-12.col-lg-3.offset-lg-4
          button.btn.btn-primary.btn-block(
            type="button"
            v-ea-click="() => {adminOpenBox(boxSelected)}"
            :disabled="!(boxSelected || {}).id"
          ) {{ $t('support.collectomate.openButton') }}
</template>

<style lang="scss" scoped>
.page {
  padding: 2rem;
  height: 76vh;
  overflow-y: auto;

  @media (max-width: 991.98px) {
    margin-bottom: 12vh;
  }

  .page__header,
  .page__description {
    margin-bottom: 1rem;
  }

  .page__footer {
    padding-top: 0rem;

    @media (max-width: 991.98px) {
      padding-top: 2rem;
    }

    &.sticky {
      padding: 0rem 2rem;
      width: 100vw;
      position: fixed;
      left: 0px;
      bottom: 0px;
      height: 11rem;
    }
  }
}

.cp-overflow-wrapper {
  overflow-x: auto;
}

.cpus {
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
</style>
